export default __webpack_public_path__ + "static/media/card-lumpsum-icon.d8065aad.svg";